import React, { Fragment } from 'react'
import { DataContext } from '../../../state/DataContext/DataContext';

// This is a component wrapper for the logout button
export default function Logout(props: any) {
    const { actions } = React.useContext(DataContext);

    const logout = () => {
        actions.Auth.Logout();
    };

    return (
        <Fragment>
            {React.cloneElement(props.children, {
                onClick: logout,
            })}
        </Fragment>
    )
}
